export const NO_DATA_FOUND = 'No data found';
